// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yaj52","card":"styles_card__uubay","section":"styles_section__Tpfj1"};